// The v2 incidents API filters trigger time only through `activatedAt`, a JSON
// range ({"startDateUTC","endDateUTC"}); it has no startDate/endDate params.
// The table's date filter stores that JSON wrapped in a one-element array.
const parseDateRange = (value) => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (!raw) return {};
    try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
        return {};
    }
};

/**
 * Build the Smart Alerts request filters from the table's selected filters,
 * falling back to the default window when no trigger time range is picked.
 */
export const buildPlatformAlertsV2Filters = (selectedFilters = {}, defaultStartDate, defaultEndDate) => {
    const { activatedAt, ...otherFilters } = selectedFilters;
    const range = parseDateRange(activatedAt);
    return {
        ...otherFilters,
        activatedAt: JSON.stringify({
            startDateUTC: range.startDateUTC || defaultStartDate,
            endDateUTC: range.endDateUTC || defaultEndDate,
        }),
    };
};
